import { defineComponent as _defineComponent } from 'vue';
import { BFormCheckbox, BFormGroup, BFormRadioGroup } from "bootstrap-vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilterMenuBoolean',
    props: {
        name: null,
        filter: null,
        filters: null,
        view: { default: "dropdown" }
    },
    emits: ["on-esc", "on-enter", "change"],
    setup(__props, { emit }) {
        const props = __props;
        const boolType = computed(() => props.filter.boolType || "default");
        const isCheckbox = computed(() => boolType.value === "is" && props.view === "compact");
        const options = boolType.value == "default"
            ? [
                { text: "Any", value: "any" },
                { text: "Yes", value: true },
                { text: "No", value: false },
            ]
            : [
                { text: "Yes", value: true },
                { text: "No", value: "any" },
            ];
        const value = computed({
            get: () => {
                const value = props.filters[props.name];
                return value !== undefined ? value : "any";
            },
            set: (newVal) => {
                const value = newVal !== null ? newVal : "any";
                emit("change", props.name, value);
            },
        });
        return { __sfc: true, props, boolType, isCheckbox, options, emit, value, BFormCheckbox, BFormGroup, BFormRadioGroup };
    }
});
